import sortBy from "lodash-es/sortBy";
import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { FuzzySelect } from "source/app/presentation/Shared/Form/Select/Fuzzy/FuzzySelect";
import * as toastr from "toastr";

interface Props {
    suggestions: string[];
    selectedLinkName: string;
    onChange: (value: string) => void;
}

export function SelectParentLink({
    suggestions,
    selectedLinkName,
    onChange,
}: Props) {
    return (
        <div>
            <FuzzySelect
                width="80%"
                label="Campaign"
                items={suggestions}
                onChangeHandler={onChange}
                selectedValue={selectedLinkName}
            />
        </div>
    );
}

export const GetParentLinkId = (allDreams: IDream[], dreamName: string) => {
    if (dreamName === "") {
        return null;
    }

    const newMasterLink = allDreams.find((dream) => dream.name === dreamName);
    const newMasterLinkId = newMasterLink ? newMasterLink.id : 0;
    return newMasterLinkId;
};

export const GetLinkSuggestions = (allDreams: IDream[]) => {
    const unlinkedDreamNames = allDreams
        .filter(HasNoLink)
        .map((dream) => dream.name);

    const suggestions = sortBy(unlinkedDreamNames, (dream) =>
        dream.toLowerCase()
    );

    return suggestions;
};

export const GetParentLinkName = (thisDream: IDream, allDreams: IDream[]) => {
    if (HasNoLink(thisDream)) {
        return "";
    }

    const parentDream = allDreams.find((elem) => elem.id === thisDream.linkid);

    if (!parentDream) {
        toastr.error("Cannot find the parent that this dream links to");
        return "";
    }

    return allDreams.find((elem) => elem.id === thisDream.linkid)!.name;
};

const HasNoLink = (dream: IDream) =>
    dream.linkid === null || dream.linkid === 0;
